import BaseRepository from "../../../common/repository/base_repository";
import CountryModel from "../model/country_model";

export default class CountryRepository extends BaseRepository {

    listUrl = '/api/country/list';
    modelClass = CountryModel;

}